export default __webpack_public_path__ + "static/media/user_thumb.e9f23ee3.png";